import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/testimonials';
import { siteInfo } from '@/mocks/site';

const PRINCIPLES = [
  '先核实、后发布，无法确认的信息不做定论',
  '同一话题保留更新记录，不悄悄修改旧稿',
  '正反观点并列呈现，不靠单方面叙述带节奏',
  '涉事方有回应渠道，更正内容公开标注',
];

export default function VoiceSection() {
  return (
    <section className="border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr]">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-wide text-primary-700">
              <i className="ri-double-quotes-l" aria-hidden="true" />
              品牌与口碑
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[28px]">
              我们只做整理，不替你下结论
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              {siteInfo.name} 是一个以「话题观察」为核心的内容站点。我们把公开信息、官方声明与网友讨论整理成可读的时间线，
              标注每次更新的时间点，让每个来到这里的读者都能自己判断，而不是被动接受一个结论。
            </p>

            <ul className="mt-6 flex flex-col gap-3">
              {PRINCIPLES.map((text) => (
                <li key={text} className="flex items-start gap-2.5 text-sm text-foreground-800">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                    <i className="ri-check-line text-xs" aria-hidden="true" />
                  </span>
                  {text}
                </li>
              ))}
            </ul>

            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              了解我们更多
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>

          <div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {testimonials.slice(0, 4).map((item) => (
                <figure
                  key={item.id}
                  className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <div className="flex items-center gap-1 text-accent-600" aria-label={`${item.rating} 星评价`}>
                    {Array.from({ length: 5 }).map((_, i) => (
                      <span key={i} className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className={i < item.rating ? 'ri-star-fill text-xs' : 'ri-star-line text-xs'} aria-hidden="true" />
                      </span>
                    ))}
                  </div>
                  <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                    {item.quote}
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                      {item.avatarText}
                    </span>
                    <span className="min-w-0">
                      <span className="block truncate text-sm font-medium text-foreground-950">{item.name}</span>
                      <span className="block truncate text-[11px] text-foreground-600">{item.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}